import Head from 'next/head';

import { PrivacyPolicySEO } from '@/utils/constants/MetaData';

const Privacy = () => {
  return (
    <>
      <Head>
        <title>{PrivacyPolicySEO.metaTitle}</title>
        <meta name="description" content={PrivacyPolicySEO.metaDescription} />
        <meta
          property="og:description"
          content={PrivacyPolicySEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/privacy-policy/"
        />
      </Head>
      <main className="home privacy-page">
        <section className="home__faq with-padding">
          <div className="container">
            <h1 className="section__title text--black text--bold">
              Privacy policy
            </h1>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_1"
              >
                <h2
                  className="text--black text--semi mt-1"
                  // style={{
                  //   fontWeight: '500',
                  // }}
                >
                  Scope of Service
                </h2>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_1">
                <p>
                  This Privacy Policy lays down the policies and guidelines
                  governing the protection of your Personal Information (as
                  defined below) including Sensitive Personal Data collected,
                  processed, and stored (as the case may be) by Muthoot Fincorp
                  Limited (“MFL” or “Muthoot FinCorp ONE” or “US” or “Our”) for
                  providing effective products and services to our users (“User”
                  or “You” or “Your”).
                </p>
                <p>
                  The Company owns and operates Mobile Application (App) /Web
                  Application by the name “Muthoot FinCorp ONE” (“App”) and
                  website at www.muthootfincorp.com (“Website”) (App and Website
                  are hereinafter together referred to as the “Platform”).
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_2"
              >
                <p>Personal Information</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_2">
                <p>
                  Personal Information means any information that relates to a
                  natural person, which, either directly or indirectly, in
                  combination with other information available or likely to be
                  available with a body corporate, is capable of identifying
                  such person.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_3"
              >
                <p>Sensitive Personal Data</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_3">
                <p>
                  Sensitive Personal data refers to the information of a person
                  that is more sensitive in nature including but not limited to
                  passwords, financial information such as bank account, credit
                  card, debit card or other payment details, physical,
                  physiological, and mental health condition, sexual
                  orientation, Aadhaar details, medical records and history and
                  biometric information (including but not limited to
                  Fingerprints, Eye retina and irises, Voice patterns, Facial
                  patterns, Hand measurement, DNA)
                </p>
                <p>
                  The personal data which is freely available to us or
                  accessible in public domain or information furnished under the
                  Right to Information Act, 2005 or any other law for the time
                  being in force or information furnished under the directives
                  of regulatory/statutory body shall not be regarded as
                  Sensitive Personal Data.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_4"
              >
                <p>Non-Personally Identifiable Information</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_4">
                <p>
                  Non-Personally Identifiable information is that information
                  which by itself, cannot be tracked to a specific individual.
                  Non-Personal information includes but not limited to your IP
                  address, cookies and third party’s cookies.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_5"
              >
                <p>Our Commitment</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_5">
                <p>
                  We are committed to protect the privacy of personal
                  information shared by you either through online on our website
                  or digital platform (Muthoot FinCorp ONE) or offline and/or
                  any personal information which may be collected by us,
                  affiliated entities, subsidiaries, our representatives or
                  agents/agencies or our server from the User’s browser.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_6"
              >
                <p>Collection of Personal/Non-Personal Information</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_6">
                <p>
                  The personal information pertaining to your identity and
                  demographics, or any non-personal information shall be
                  collected by us for enabling us to provide following services:
                </p>
                <p>
                  1. Lending Services and Non-Lending Services- Information will
                  be collected by MFL Branches while providing lending and
                  non-lending services.
                </p>
                <p>
                  2. Digital Lending and Non-Lending Services- Information will
                  be collected by Muthoot FinCorp ONE (Platform) for
                  facilitation of lending and non-lending services offered by
                  the MFL and other financial lending partners whose list is
                  available on the website and who are registered with the
                  Reserve Bank of India.{' '}
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_7"
              >
                <p>What type of information Muthoot FinCorp ONE collects?</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_7">
                <p>
                  When you visit our website/platform or mobile app, we collect
                  the following types of information from you:
                </p>
                <p>
                  1. Contact Information: Your name, address, phone no, email
                  Id, date of birth, gender, and other similar information.
                </p>
                <p>
                  2. Financial Information: UPI VPAs, part of card details, bank
                  account numbers, bank statements, bank IFSC codes, wallet
                  balance, your billers bank account number and IFSC and
                  information related to your all successful and failed payment
                  attempts, nominee details and their contact number. Reference
                  details and their contact numbers; Income Tax details, GST
                  details, TDS details etc
                </p>
                <p>
                  3. Location Information: Full addresses, latitude and
                  longitude of locations shared by you, state, city, pin codes
                  etc
                </p>
                <p>
                  4. KYC Information: Your photo, PAN no, PAN copy, Aadhar No,
                  address proof ID no., picture, and address proof copy.
                </p>
                <p>
                  5. Type of Address Proofs: Driving licence, voter ID,
                  passport, Aadhar information in encrypted form.
                </p>
                <p>
                  6. Demographic and related information: Income, location, age,
                  gender, preference, occupation and interests.
                </p>
                <p>
                  7. OTP sent by Muthoot FinCorp ONE or Muthoot Group Entities
                  (MPG).
                </p>
                <p>
                  8. Device details such as device identifier, internet
                  bandwidth, mobile device model, browser plug-ins, and cookies
                  or similar technologies that may identify your browser/
                  Muthoot FinCorp ONE Application and plug-ins, and time spent,
                  IP address and location.
                </p>
                <p>
                  9. Other Information relevant to capture feedback, transaction
                  experience and to push customised marketing offers.
                </p>
                <p>
                  Contact us- if you email us through the “Contact Us” section
                  on the website, we ask you for information such as your name
                  and email address so we can respond to your questions and
                  comments. You may choose to provide additional information as
                  well.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_8"
              >
                <p>Usage of your Personal Information</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_8">
                <p>
                  Any of the information we collect from you may be used in one
                  of the following ways:
                </p>
                <p>
                  1. To personalize your experience - Your information helps us
                  to respond to your individual needs in a better way.
                </p>
                <p>2. To verify your identity as per applicable laws.</p>
                <p>
                  3. To improve your experience with our website/app/platform -
                  We continually strive to improve our website/app/platform
                  offerings based on the information and feedback we receive
                  from you.
                </p>
                <p>
                  4. To improve customer service - Your information helps us to
                  respond to your service requests and support needs more
                  effectively.
                </p>
                <p>5. To process your transactions easily.</p>
                <p>
                  6. To administer a contest, promotion, survey, or other site
                  feature – We shall reach out to you when we are conducting any
                  contests or surveys. You may opt out if you do not wish to be
                  included.
                </p>
                <p>
                  7. To send periodic emails, SMSs, WhatsApp messages &
                  occasionally in-bound phone calls - The email address or
                  mobile number that you provide may be used to send you
                  information, respond to inquiries, and/or other requests or
                  questions.
                </p>
                <p>
                  8. To keep you informed about our new products or services
                  unless you unsubscribe to our emails.
                </p>
                <p>
                  9. To carry out research and analysis to study customer use
                  and experience on an anonymous or personalized basis.
                </p>
                <p>
                  10. Other usages that you may consent to including WhatsApp
                  for Business.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_9"
              >
                <p>Information we share</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_9">
                <p>
                  Group Companies, authorised agents or trusted third party
                  service providers who assist us in operating our website,
                  conducting our business, or servicing you shall have access to
                  your information on need-to-know basis and are restricted from
                  using the same for any other reason. The third-party service
                  provider is obligated not to disclose or use the information
                  for any other purpose.{' '}
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_10"
              >
                <p>Consent</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_10">
                <p>
                  You hereby expressly consent to provide the information that
                  may be required for providing the services as mentioned above.
                  You acknowledge that we shall collect the information as per
                  this privacy policy to provide/facilitate lending and
                  non-lending services by us or by partnering with various
                  financial lenders, third parties, service providers etc.{' '}
                </p>
                <p>
                  IT IS ADVISED THAT YOU READ, UNDERSTAND, ACKNOWLEDGE AND
                  UNCONDITIONALLY AGREE TO BE BOUND BY THE TERMS AND CONDITIONS
                  OF THIS PRIVACY POLICY.{' '}
                </p>
                <p>
                  IF YOU DO NOT AGREE TO THIS POLICY OR ANY PART THEREOF, PLEASE
                  DO NOT USE/ACCESS/DOWNLOAD/INSTALL THE PLATFORM OR ANY PART
                  THEREOF.{' '}
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_11"
              >
                <p>Acknowledgment of the User</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_11">
                <p>
                  You agree that MFL and /or MPG shall have every right to use
                  the Information to initiate the dialogue with you with respect
                  to various products, services and other allied and necessary
                  requirements as may be deemed necessary by MFL.
                </p>
                <p>
                  You acknowledge that you are completely aware about the
                  potential risk of data/privacy breach and hereby confirms that
                  you shall be solely liable for any unauthorized
                  disclosure/breach personal/sensitive personal information, etc
                  and any direct/indirect losses suffered. Hence, you shall
                  exercise utmost caution to ensure that your information is NOT
                  shared/stored/made accessible through
                </p>
                <p className="blog_point">
                  (i) any physical means with or without your knowledge
                  (disclosure to any person/third party; etc) or
                </p>
                <p className="blog_point">
                  (ii) through any electronic means, by exercising the following
                  precautions/safety measures
                </p>
                <p>
                  1. You shall always check if “https” appears in any website’s
                  address bar before making any online transaction, to ensure
                  that the webpage is encrypted.
                </p>
                <p>
                  2. You shall avoid using untrusted third-party extensions,
                  plug-ins, or add-ons on the app/your web browser, as it may
                  result in the risk of tracking or stealing of personal
                  details. Muthoot FinCorp ONE app & website uses a set of
                  trusted third-party SDKs, extensions, plug-ins and addons.
                  Personal Information may be collected by respective service
                  providers shall be as per their privacy policy. You may refer
                  to their privacy policy and terms of service to understand how
                  your Personal Information will be handled by such service
                  providers.{' '}
                </p>
                <p>
                  3. You shall always type the information and not use the
                  auto-fill option on web browser to prevent the risk of storage
                  of my personal/sensitive personal information.
                </p>
                <p>
                  4. You shall NOT access darknet, unauthorized/suspicious
                  websites, suspicious online platforms, downloading
                  applications from unreliable sources.
                </p>
                <p>
                  5. You shall ensure to disable cookies before accessing any
                  domain/website, to ensure that your personal information is
                  not tracked by any third party, unless otherwise consciously
                  permitted by you by accepting the same, for which, you are
                  solely responsible for the consequences thereof.
                </p>
                <p>
                  6. You shall NOT respond to any generic emails from an
                  unknown/unidentified source.
                </p>
                <p>
                  7. You shall check the Privacy Policy of the
                  website/application to know the type of information that may
                  be collected from you and the manner in which it may be
                  processed by the website/application before
                  accepting/proceeding/transaction on any website/application.
                </p>
                <p>
                  8. You shall always verify and install authentic web/mobile
                  applications from reliable source on User’s
                  computer/laptop/tab/ipad/smart phone or any other electronic
                  device.
                </p>
                <p>
                  9. Apart from the communication sent by us through trusted
                  weblinks or short URLs leading to hosted webpage / app of
                  Muthoot FinCorp ONE, you shall NOT access any unidentified
                  weblinks, bitly link or any other electronic links shared over
                  electronic platform (such as email, sms, social media,
                  websites).
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_12"
              >
                <p>Protection of Personal Information</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_12">
                <p>
                  We implement a variety of security measures to protect your
                  personal information from unauthorized access or disclosure.
                  Further our employees who have limited access to your personal
                  information are bound by Non-Disclosure and Confidentiality
                  Policies. You will appreciate the fact that no method of
                  transmission, whether in physical form or over the internet,
                  or method of electronic storage is 100% secure and maybe
                  subjected to unintentional risks, due to reasons beyond our
                  control.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_13"
              >
                <p>Disclosure of Personal Information</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_13">
                <p>
                  We do not sell, trade, or otherwise transfer to outside
                  parties your personally identifiable information. However, we
                  might share or disclose information to Group Companies,
                  authorised agents or any trusted third-party service providers
                  who assist us in operating our website, conducting our
                  business, or servicing you, so long as those parties comply
                  with applicable laws and agree to keep this information
                  confidential.
                </p>
                <p>
                  1. Your Personal Information may be transferred to outside
                  parties under following circumstances: We may share the
                  personal information with other Group Companies or other
                  trusted entities or agents or representative who act on our
                  behalf to call and communicate with you about products
                  offerings through Telephone/Mobile/SMS/Email/WhatsApp.
                </p>
                <p>
                  2. We may share the personal information with the statutory
                  and/or regulatory authorities, government institutions where
                  required for compliance with legal requirement.
                </p>
                <p>
                  3. We may use the personal information to respond to court
                  orders or legal process to establish or exercise our legal
                  rights or defend against legal claims.
                </p>
                <p>
                  4. We may share the personal information in order to
                  investigate, prevent, or take action against any illegal
                  activities, suspected fraud, or as otherwise required by law.
                </p>
                <p>
                  5. We may share the personal information in order to protect
                  or enforce our rights and claims.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_14"
              >
                <p>Retention of Personal Information</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_14">
                <p>
                  We will retain your Personal information for as long as
                  necessary to provide you the services, or for complying with
                  our statutory/regulatory obligations, resolving disputes,
                  defending the claims, and enforcing our policies. Muthoot
                  FinCorp ONE in case dealing with users for providing services
                  as offered by other lending partners will only store basic
                  personal information such as name, address, contact
                  information which are required to be stored for carrying out
                  non-lending services and transfer the same to the lending
                  partners upon completion of onboarding.
                </p>
                <p>
                  All the data or information we collect you is stored in
                  servers located in India.
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_15"
              >
                <p>Changes to the Privacy Policy</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_15">
                <p>
                  This Privacy Policy shall be amended from time to time to
                  comply with our business requirements and applicable laws. The
                  amendments made to this Privacy Policy shall be updated on
                  this website. You may visit this website to view the changes
                  in policy. These changes are effective immediately after they
                  are posted on our website. Please regularly check this Privacy
                  Policy to ensure you are aware of the latest updates.{' '}
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_16"
              >
                <p>Modification and Rectification of Information</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_16">
                <p>
                  If the personal information provided by you is inaccurate,
                  incomplete or outdated, in that case you can reach to us at
                  customercare@muthoot.com for rectifying the same.{' '}
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_17"
              >
                <p>Withdrawal/Denial of Consent</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_17">
                <p>
                  You have a right to withdraw the consent already granted or
                  deletion of your Muthoot FinCorp ONE login account or deny the
                  consent for use of specific data, restrict to disclosure to
                  third parties, data retention, revoke consent already granted
                  to collect personal data and if required, make App
                  delete/forget the data by writing us at{' '}
                  <a href="mailto:customercare@muthoot.com">
                    customercare@muthoot.com
                  </a>
                  . Further if you have availed any service from the Company or
                  our lending partners, the Company and lending partners shall
                  have a right to continue processing your information till such
                  credit facility have been repaid in full together with any
                  interest and dues payable.{' '}
                </p>
              </div>
            </div>
            <div className="faq">
              <div
                className="faq__header collapsed"
                data-toggle="collapse"
                data-target="#question_18"
              >
                <p>Contact us</p>
                <span></span>
              </div>
              <div className="faq__answer collapse" id="question_18">
                <p>
                  In case if you may want to share your concern, we welcome you
                  to easily reach out to us through multiple contact options
                  displayed on our website
                </p>
                <p>
                  <a href="https://www.muthootfincorp.com/">
                    https://www.muthootfincorp.com
                  </a>{' '}
                  , <a href="https://muthoot.com">https://www.muthoot.com</a> ,
                  and{' '}
                  <a href="https://www.muthootfincorpone.com">
                    https://www.muthootfincorpone.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Privacy;
